import styled from "styled-components";

const P = styled.p`
  font-size: 1.875rem;
  letter-spacing: 0px;
  line-height: 1.5;
  font-weight: 300;
`

export default P